import { FlavorDto } from "@juicy/models/dto";
import { Card, Icon, Text } from "@ui-kitten/components";
import React, { useEffect, useState } from "react";
import { StyleSheet, View } from "react-native";
import { useToast } from "react-native-toast-notifications";
import { apiService } from "../../App";
import { DataListType, useDataList } from "../common/dataList/useDataList";
import { getColorForRating, Rating } from "../recipe/rating";

interface FlavorListItemProps {
    flavor: FlavorDto;
    disableRating: boolean;
    onPress: () => void;
}

export const FlavorListItem: React.FC<FlavorListItemProps> = ({ flavor, disableRating, onPress }) => {
    const [internalFlavor, setInternalFlavor] = useState<FlavorDto>(flavor);

    const handleSaveRating = async (rating?: number) => {
        const newFlavor = { ...flavor, rating };
        await apiService.flavors.edit(newFlavor);
        setInternalFlavor(newFlavor);
    };

    useEffect(() => {
        setInternalFlavor(flavor);
    }, [flavor]);

    return (
        <Card
            style={{
                borderLeftWidth: 2,
                borderLeftColor: getColorForRating(internalFlavor.rating),
            }}
            onPress={onPress}
        >
            <View style={styles.root}>
                <View style={{ flexDirection: "column" }}>
                    <View
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            // justifyContent: "center",
                        }}
                    >
                        <Text numberOfLines={1} ellipsizeMode="tail" category="s1">
                            {internalFlavor.fullName || internalFlavor.name}
                        </Text>
                        {internalFlavor.warning && (
                            <Icon name="alert-triangle-outline" style={{ width: 16, height: 16, marginLeft: 10 }} />
                        )}
                    </View>
                    <Text style={{ marginTop: 5 }} numberOfLines={1} ellipsizeMode="tail" category="c2">
                        {new Date(internalFlavor.createdAt).toDateString()}
                    </Text>
                </View>
                <Rating
                    size="large"
                    rating={internalFlavor.rating}
                    onChange={handleSaveRating}
                    disabled={disableRating}
                />
            </View>
        </Card>
    );
};

const styles = StyleSheet.create({
    root: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
    },
});
